import { AccordionActions } from "@material-ui/core";
import { PROJECTMILESTONE } from "../actions/utilities";

const INITIAL_STATE = {
  getProjectMilestoneLoading: false,
  getProjectMilestoneSuccess: false,
  getProjectMilestoneFailure: false,
  getProjectMilestoneError: null,

  getProjectMilestoneSelectListLoading: false,
  getProjectMilestoneSelectListSuccess: false,
  getProjectMilestoneSelectListFailure: false,
  getProjectMilestoneSelectListError: null,

  addProjectMilestoneLoading: false,
  addProjectMilestoneSuccess: false,
  addProjectMilestoneFailure: false,
  addProjectMilestoneError: null,
  addProjectMilestoneData: null,

  deleteProjectMilestoneLoading: false,
  deleteProjectMilestoneSuccess: false,
  deleteProjectMilestoneFailure: false,
  deleteProjectMilestoneError: null,

  createTaskInMilestoneLoading: false,
  createTaskInMilestoneSuccess: false,
  createTaskInMilestoneFailure: false,
  createTaskInMilestoneError: null,

  editTaskInMilestoneLoading: false,
  editTaskInMilestoneSuccess: false,
  editTaskInMilestoneFailure: false,
  editTaskInMilestoneError: null,

  fetchTaskInMilestoneLoading: false,
  fetchTaskInMilestoneSuccess: false,
  fetchTaskInMilestoneFailure: false,
  fetchTaskInMilestoneError: null,

  deleteTaskInMilestoneSuccess: false,
  deleteTaskInMilestoneLoading: false,
  deleteTaskInMilestoneFailure: false,
  deleteTaskInMilestoneError: null,

  addCommentInTaskSuccess: false,
  addCommentInTaskLoading: false,
  addCommentInTaskFailure: false,
  addCommentInTaskError: null,

  deleteCommentLoading: false,
  deleteCommentSuccess: false,
  deleteCommentFailure: false,
  deleteCommentError: null,

  getCommentInTaskSuccess: false,
  getCommentInTaskLoading: false,
  getCommentInTaskFailure: false,
  getCommentInTaskError: null,

  changeTaskMilestoneSuccess: false,
  changeTaskMilestoneLoading: false,
  changeTaskMilestoneFailure: false,
  changeTaskMilestoneError: null,

  filterMilestones: [],
  projectMilestoneSummary: null,
  projectMilestones: [],
  projectMilestonesTasks: [],
  totalMilestonesRecords: null,
  totalMilestoneTasksRecords: null,
  mileStonesSelectList: [],

  startSprintSuccess: false,
  startSprintLoading: false,
  startSprintFailure: false,
  startSprintError: null,

  checkTaskCompletedAgainstSprintSuccess: false,
  checkTaskCompletedAgainstSprintLoading: false,
  checkTaskCompletedAgainstSprintFailure: false,
  checkTaskCompletedAgainstSprintError: null,

  getAllSprintsWithoutStartedSprintSuccess: false,
  getAllSprintsWithoutStartedSprintLoading: false,
  getAllSprintsWithoutStartedSprintFailure: false,
  getAllSprintsWithoutStartedSprintError: null,
  getAllSprintsWithoutStartedSprint: [],

  moveSprintTaskSuccess: false,
  moveSprintTaskLoading: false,
  moveSprintTaskFailure: false,
  moveSprintTaskError: null,
};

export const projectMilestoneReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROJECTMILESTONE.FILTER_PROJECT_MILESTONE:
      state.filterMilestones = [];
      if (typeof action.payload == "number") {
        for (let index = 0; index < state.projectMilestones.length; index++) {
          if (state.projectMilestones[index].statusId === action.payload) {
            state.filterMilestones.push(state.projectMilestones[index]);
          }
        }
      } else {
        state.filterMilestones = state.projectMilestones.filter((milestone) =>
          milestone.title.match(action.payload)
        );
      }
      state.filterMilestones = [...state.filterMilestones];
      return {
        ...state,
      };
    //add comment
    case PROJECTMILESTONE.ADD_COMMENT_IN_TASK_SUCCESS:
      var indexInfo = action.info;
      var receivedObj = action.payload;
      var task =
        state.projectMilestones[indexInfo.milestoneIndex].task[
          indexInfo.taskIndex
        ];
      if (receivedObj.parentId && receivedObj.parentId > 0) {
        //if parentId exist means its a reply
        if (
          task.comments[indexInfo.commentIndex].replies == null ||
          !("replies" in task.comments[indexInfo.commentIndex])
        )
          task.comments[indexInfo.commentIndex].replies = [];
        var replies = task.comments[indexInfo.commentIndex].replies;
        var findReply = replies.filter(
          (r) => r.commentId == receivedObj.commentId
        );
        if (findReply && findReply.length > 0) {
          //its an edit case for reply
          replies[indexInfo.replyIndex] = receivedObj;
        } else {
          replies.push(receivedObj);
        }
        task.comments[indexInfo.commentIndex].replies = replies;
      } else {
        var comments = task.comments;
        var findComment =
          comments &&
          task.comments.filter((r) => r.commentId == receivedObj.commentId);
        if (findComment && findComment.length > 0) {
          //its an comment add case
          comments[indexInfo.commentIndex] = receivedObj;
        } else {
          comments.push(receivedObj);
        }
        task.comments = comments;
      }
      state.projectMilestones[indexInfo.milestoneIndex].task[
        indexInfo.taskIndex
      ] = task;
      // console.log("finally => ", task)
      return {
        ...state,
        addCommentInTaskSuccess: true,
      };
    //fetch comment
    case PROJECTMILESTONE.GET_COMMENT_IN_TASK_FAILURE:
      return {
        ...state,
        getCommentInTaskFailure: true,
      };
    // case PROJECTMILESTONE.GET_COMMENT_IN_TASK_SUCCESS:
    //   debugger;
    //   if (action?.payload != null)
    //     state.projectMilestones[action.info.milestoneIndex].task[
    //       action.info.taskIndex
    //     ].comments = [...action.payload];
    //   return {
    //     ...state,
    //     getCommentInTaskSuccess: true,
    //   };
    case PROJECTMILESTONE.GET_COMMENT_IN_TASK_SUCCESS:
      const { milestoneIndexGet, taskIndex } = action.info;

      if (
        !state.projectMilestones[milestoneIndexGet] ||
        !state.projectMilestones[milestoneIndexGet].task ||
        !state.projectMilestones[milestoneIndexGet].task[taskIndex]
      ) {
        console.warn("Invalid milestoneIndex or taskIndex", action.info);
        return state; // or log/report for debugging
      }

      state.projectMilestones[milestoneIndexGet].task[taskIndex].comments = [
        ...action.payload,
      ];
      return {
        ...state,
        getCommentInTaskSuccess: true,
      };
    case PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_REQUEST:
      return {
        ...state,
        deleteCommentLoading: true,
      };
    //delete comment
    case PROJECTMILESTONE.DELETE_COMMENT_IN_TASK_SUCCESS:
      var indexInfo = action.info;
      var task =
        state.projectMilestones[indexInfo.milestoneIndex].task[
          indexInfo.taskIndex
        ];
      var newComments = task.comments;
      if (!newComments) {
        newComments = [];
      }
      if (indexInfo.replyIndex != null) {
        var replies = newComments[indexInfo.commentIndex].replies;
        replies.splice(indexInfo.replyIndex, 1);
        newComments[indexInfo.commentIndex].replies = replies;
      } else {
        newComments.splice(indexInfo.commentIndex, 1);
      }
      task.comments = newComments;
      state.projectMilestones[indexInfo.milestoneIndex].task[
        indexInfo.taskIndex
      ] = task;
      return {
        ...state,
        deleteCommentSuccess: true,
      };

    case PROJECTMILESTONE.GET_PROJECT_MILESTONE_REQUEST:
      return {
        ...state,
        getProjectMilestoneLoading: true,
        getProjectMilestoneSuccess: false,
        getProjectMilestoneFailure: false,
        getProjectMilestoneError: null,
        totalMilestonesRecords: null,
      };
    case PROJECTMILESTONE.GET_PROJECT_MILESTONE_SUCCESS:
      return {
        ...state,
        getProjectMilestoneLoading: false,
        getProjectMilestoneSuccess: true,
        getProjectMilestoneFailure: false,
        getProjectMilestoneError: null,
        projectMilestones: action.payload.records,
        totalMilestonesRecords: action.payload.totalRecords,
      };
    case PROJECTMILESTONE.GET_PROJECT_MILESTONE_FAILURE:
      return {
        ...state,
        getProjectMilestoneLoading: false,
        getProjectMilestoneSuccess: false,
        getProjectMilestoneFailure: true,
        getProjectMilestoneError: action.payload,
        totalMilestonesRecords: null,
      };

    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_REQUEST:
      return {
        ...state,
        fetchTaskInMilestoneLoading: true,
        fetchTaskInMilestoneSuccess: false,
        fetchTaskInMilestoneFailure: false,
        fetchTaskInMilestoneError: null,
        totalMilestonesRecords: null,
      };
    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_SUCCESS:
      return {
        ...state,
        fetchTaskInMilestoneLoading: false,
        fetchTaskInMilestoneSuccess: true,
        fetchTaskInMilestoneFailure: false,
        fetchTaskInMilestoneError: null,
        projectMilestonesTasks: action.payload.records,
        totalMilestonesRecords: action.payload.totalRecords,
      };
    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_FAILURE:
      return {
        ...state,
        fetchTaskInMilestoneLoading: false,
        fetchTaskInMilestoneSuccess: false,
        fetchTaskInMilestoneFailure: true,
        fetchTaskInMilestoneError: null,
        projectMilestonesTasks: action.payload,
        totalMilestonesRecords: null,
      };

    case PROJECTMILESTONE.DELETE_PROJECT_MILESTONE_SUCCESS:
      var milestoneIndex = -1;
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId === action.payload
        ) {
          milestoneIndex = index;
        }
      }
      if (milestoneIndex >= 0)
        state.projectMilestones.splice(milestoneIndex, 1);
      state.projectMilestones = [...state.projectMilestones];
      return {
        ...state,
        deleteProjectMilestoneLoading: false,
        deleteProjectMilestoneSuccess: true,
        deleteProjectMilestoneFailure: false,
        deleteProjectMilestoneError: null,
      };
    case PROJECTMILESTONE.ADD_PROJECT_MILESTONE_REQUEST:
      return {
        ...state,
        addProjectMilestoneLoading: true,
        addProjectMilestoneSuccess: false,
        addProjectMilestoneFailure: false,
        addProjectMilestoneError: null,
      };
    case PROJECTMILESTONE.ADD_PROJECT_MILESTONE_SUCCESS:
      var milestoneIndex = -1;
      var updatedMileStones = null;
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId ===
          action.payload.projectMilestoneId
        ) {
          milestoneIndex = index;
        }
      }

      // console.log('reducer called');
      if (milestoneIndex >= 0)
        state.projectMilestones[milestoneIndex] = action.payload;
      else state.projectMilestones.splice(0, 0, action.payload);
      state.projectMilestones = [...state.projectMilestones];
      // console.log('reducer => ', state.projectMilestones);
      return {
        ...state,
        addProjectMilestoneLoading: false,
        addProjectMilestoneSuccess: true,
        addProjectMilestoneFailure: false,
        addProjectMilestoneError: null,
        projectMilestones: state.projectMilestones,
      };
    case PROJECTMILESTONE.ADD_PROJECT_MILESTONE_FAILURE:
      return {
        ...state,
        addProjectMilestoneLoading: false,
        addProjectMilestoneSuccess: false,
        addProjectMilestoneFailure: true,
        addProjectMilestoneError: action.payload,
      };
    //create TaskInMilestone
    case PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_REQUEST:
      return {
        ...state,
        createTaskInMilestoneLoading: true,
        createTaskInMilestoneSuccess: false,
        createTaskInMilestoneFailure: false,
        createTaskInMilestoneError: null,
      };
    case PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_SUCCESS: {
      if (!action.payload) return state;

      const updatedProjectMilestones = state.projectMilestones.map(
        (milestone) => {
          if (
            milestone.projectMilestoneId === action.payload.projectMilestoneId
          ) {
            return {
              ...milestone,
              task: [action.payload, ...(milestone.task || [])],
              toDoMilestoneTasks: (milestone.toDoMilestoneTasks || 0) + 1,
              totalMilestoneTasks: (milestone.totalMilestoneTasks || 0) + 1,
            };
          }
          return milestone;
        }
      );

      return {
        ...state,
        createTaskInMilestoneLoading: false,
        createTaskInMilestoneSuccess: true,
        createTaskInMilestoneFailure: false,
        createTaskInMilestoneError: null,
        projectMilestones: updatedProjectMilestones,
      };
    }

    case PROJECTMILESTONE.CREATE_TASK_IN_MILESTONE_FAILURE:
      return {
        ...state,
        createTaskInMilestoneLoading: false,
        createTaskInMilestoneSuccess: false,
        createTaskInMilestoneFailure: true,
        createTaskInMilestoneError: action.payload,
      };
    //edit task in milestone
    case PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_REQUEST:
      return {
        ...state,
        editTaskInMilestoneLoading: true,
        editTaskInMilestoneSuccess: false,
        editTaskInMilestoneFailure: false,
        editTaskInMilestoneError: null,
      };
    case PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_SUCCESS:
      let editTask = state.projectMilestones[action.info.milestoneIndex];

      if (action.payload != null) {
        editTask.task[action.info.taskIndex] = action.payload;
      }
      state.projectMilestones[action.info.milestoneIndex].task = [
        ...state.projectMilestones[action.info.milestoneIndex].task,
      ];
      return {
        ...state,
        editTaskInMilestoneLoading: false,
        editTaskInMilestoneSuccess: true,
        editTaskInMilestoneFailure: false,
        editTaskInMilestoneError: null,
      };
    case PROJECTMILESTONE.EDIT_DELETE_TASK_IN_MILESTONE_SUCCESS:
      let prevmilestoneIndex = 0;
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId ===
          action.payload.projectMilestoneId
        ) {
          prevmilestoneIndex = index;
          break;
        }
      }
      if ("task" in state.projectMilestones[prevmilestoneIndex]) {
        let prevTaskIndex = -1;
        for (
          let index = 0;
          index < state.projectMilestones[prevmilestoneIndex].task.length;
          index++
        ) {
          if (
            state.projectMilestones[prevmilestoneIndex].task[index].taskId ===
            action.payload.taskId
          ) {
            prevTaskIndex = index;
            break;
          }
        }
        if (prevTaskIndex > -1) {
          state.projectMilestones[prevmilestoneIndex].task.splice(
            prevTaskIndex,
            1
          );
        }
      }
      return {
        ...state,
        editTaskInMilestoneLoading: false,
        editTaskInMilestoneSuccess: true,
        editTaskInMilestoneFailure: true,
        editTaskInMilestoneError: null,
        projectMilestones: state.projectMilestones,
      };
    case PROJECTMILESTONE.EDIT_TASK_IN_MILESTONE_FAILURE:
      return {
        ...state,
        editTaskInMilestoneLoading: false,
        editTaskInMilestoneSuccess: false,
        editTaskInMilestoneFailure: true,
        editTaskInMilestoneError: action.payload,
      };
    //edit task in mileston
    case PROJECTMILESTONE.DELETE_TASK_IN_MILESTONE_SUCCESS:
      if (
        !state.projectMilestones ||
        !state.projectMilestones[action.payload.milestoneIndex] ||
        !state.projectMilestones[action.payload.milestoneIndex].task
      ) {
        console.error("Invalid milestoneIndex or task list is undefined");
        return state; // Exit reducer to prevent crash
      }

      // Create a new immutable copy to avoid modifying state directly
      const updatedMilestones1 = [...state.projectMilestones];
      updatedMilestones1[action.payload.milestoneIndex] = {
        ...updatedMilestones1[action.payload.milestoneIndex],
        task: updatedMilestones1[action.payload.milestoneIndex].task.filter(
          (_, index) => index !== action.payload.taskIndex
        ),
      };

      // Update task counters based on task type
      switch (action.payload.taskType) {
        case 2:
          updatedMilestones1[
            action.payload.milestoneIndex
          ].inProgressMilestoneTasks -= 1;
          updatedMilestones1[
            action.payload.milestoneIndex
          ].totalMilestoneTasks -= 1;
          if (action.payload.isOverDue) {
            updatedMilestones1[
              action.payload.milestoneIndex
            ].overDueMilestoneTasks -= 1;
          }
          break;
        case 4:
          updatedMilestones1[
            action.payload.milestoneIndex
          ].completedMilestoneTask -= 1;
          updatedMilestones1[
            action.payload.milestoneIndex
          ].totalMilestoneTasks -= 1;
          if (action.payload.isOverDue) {
            updatedMilestones1[
              action.payload.milestoneIndex
            ].overDueMilestoneTasks -= 1;
          }
          break;
        case 5:
          updatedMilestones1[
            action.payload.milestoneIndex
          ].toDoMilestoneTasks -= 1;
          updatedMilestones1[
            action.payload.milestoneIndex
          ].totalMilestoneTasks -= 1;
          if (action.payload.isOverDue) {
            updatedMilestones1[
              action.payload.milestoneIndex
            ].overDueMilestoneTasks -= 1;
          }
          break;
        default:
          console.warn("Unknown task type:", action.payload.taskType);
          break;
      }

      return {
        ...state,
        deleteTaskInMilestoneSuccess: true,
        projectMilestones: updatedMilestones1, // ✅ Update state immutably
      };

    //fetch TaskInMilestone
    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_REQUEST:
      return {
        ...state,
        fetchTaskInMilestoneLoading: true,
        fetchTaskInMilestoneSuccess: false,
        fetchTaskInMilestoneFailure: false,
        fetchTaskInMilestoneError: null,
      };
    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_SUCCESS:
      let getMilestoneIndex = 0;
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId ===
          action.info.milestoneId
        ) {
          getMilestoneIndex = index;
          break;
        }
      }
      if (action.payload != null && action.payload.records.length > 0) {
        state.projectMilestoneSummary = {};
        state.projectMilestones[getMilestoneIndex].task =
          action.payload.records;
        state.projectMilestoneSummary.totalMilestoneTask =
          state.projectMilestones[getMilestoneIndex].totalMilestoneTasks;
        state.projectMilestoneSummary.completedMilestoneTask =
          state.projectMilestones[getMilestoneIndex].completedMilestoneTasks;
        state.projectMilestoneSummary.inProgressMilestoneTask =
          state.projectMilestones[getMilestoneIndex].inProgressMilestoneTasks;
        state.projectMilestoneSummary.overDueMilestoneTask =
          state.projectMilestones[getMilestoneIndex].overDueMilestoneTasks;
        state.projectMilestoneSummary.toDoMilestoneTasks =
          state.projectMilestones[getMilestoneIndex].toDoMilestoneTasks;
        state.totalMilestoneTasksRecords = action.payload.totalRecords;
      } else {
        state.projectMilestones[getMilestoneIndex].task =
          action.payload.records;
        state.projectMilestoneSummary = {};
        state.totalMilestoneTasksRecords = 0;
      }
      return {
        ...state,
        fetchTaskInMilestoneLoading: false,
        fetchTaskInMilestoneSuccess: true,
        fetchTaskInMilestoneFailure: false,
        fetchTaskInMilestoneError: null,
      };
    case PROJECTMILESTONE.CHANGE_TASK_MILESTONE_SUCCESS:
      state.projectMilestones[action.info.milestoneIndex].task.splice(
        action.info.taskIndex,
        1
      );
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId ===
          action.payload.projectMilestoneId
        ) {
          state.projectMilestones[index].task &&
            state.projectMilestones[index].task.push(action.payload);
        }
      }
      state.projectMilestones[action.info.milestoneIndex].task = [
        ...state.projectMilestones[action.info.milestoneIndex].task,
      ];
      return {
        ...state,
        changeTaskMilestoneSuccess: true,
      };
    case PROJECTMILESTONE.FETCH_TASK_IN_MILESTONE_FAILURE:
      return {
        ...state,
        fetchTaskInMilestoneLoading: false,
        fetchTaskInMilestoneSuccess: false,
        fetchTaskInMilestoneFailure: true,
        fetchTaskInMilestoneError: action.payload,
      };
    case PROJECTMILESTONE.CHANGE_RELEASE_STATUS_SUCCESS:
      var milestoneIndex = -1;
      for (let index = 0; index < state.projectMilestones.length; index++) {
        if (
          state.projectMilestones[index].projectMilestoneId ===
          action.payload.releaseId
        ) {
          milestoneIndex = index;
          break;
        }
      }
      var status = action.payload.statusId === 151 ? "Released" : "Un-Released";
      var completedDate = new Date();
      // console.log('reducer => completedDate', completedDate);
      if (milestoneIndex > -1) {
        state.projectMilestones[milestoneIndex].status = status;
        state.projectMilestones[milestoneIndex].statusId =
          action.payload.statusId;
        state.projectMilestones[milestoneIndex].completedDate = completedDate;
      }
      state.projectMilestones = [...state.projectMilestones];
      return {
        ...state,
        changeReleaseStatusSuccess: true,
      };

    //////////

    case PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_REQUEST:
      return {
        ...state,
        getProjectMilestoneSelectListLoading: true,
        getProjectMilestoneSelectListSuccess: false,
        getProjectMilestoneSelectListFailure: false,
        getProjectMilestoneSelectListError: null,
        mileStonesSelectList: [],
      };
    case PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_SUCCESS:
      return {
        ...state,
        getProjectMilestoneSelectListLoading: false,
        getProjectMilestoneSelectListSuccess: true,
        getProjectMilestoneSelectListFailure: false,
        getProjectMilestoneSelectListError: null,
        mileStonesSelectList: action.payload,
      };
    case PROJECTMILESTONE.GET_PROJECT_MILESTONES_SELECTLIST_FAILURE:
      return {
        ...state,
        getProjectMilestoneSelectListLoading: false,
        getProjectMilestoneSelectListSuccess: false,
        getProjectMilestoneSelectListFailure: true,
        getProjectMilestoneSelectListError: null,
        mileStonesSelectList: [],
      };
    case PROJECTMILESTONE.START_SPRINT_REQUEST:
      return {
        ...state,
        startSprintLoading: true,
        startSprintSuccess: false,
        startSprintFailure: false,
        startSprintError: null,
      };
    case PROJECTMILESTONE.START_SPRINT_SUCCESS:
      const updatedMilestones = [...state.projectMilestones];
      for (let i = 0; i < updatedMilestones.length; i++) {
        if (updatedMilestones[i].projectMilestoneId === action.payload) {
          updatedMilestones[i].isMilesStoneStart = true;
          break;
        }
      }
      return {
        ...state,
        startSprintLoading: false,
        startSprintSuccess: true,
        startSprintFailure: false,
        startSprintError: null,
        projectMilestones: updatedMilestones,
      };
    case PROJECTMILESTONE.START_SPRINT_FAILURE:
      return {
        ...state,
        startSprintLoading: false,
        startSprintSuccess: false,
        startSprintFailure: true,
        startSprintError: action.payload,
      };
    case PROJECTMILESTONE.CLEAR_START_SPRINT_ERROR:
      return {
        ...state,
        startSprintError: null,
      };
    case PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_REQUEST:
      return {
        ...state,
        checkTaskCompletedAgainstSprintLoading: true,
        checkTaskCompletedAgainstSprintSuccess: false,
        checkTaskCompletedAgainstSprintFailure: false,
        checkTaskCompletedAgainstSprintError: null,
      };
    case PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_SUCCESS:
      const completeMilestones = [...state.projectMilestones];
      for (let i = 0; i < completeMilestones.length; i++) {
        if (completeMilestones[i].projectMilestoneId === action.payload) {
          completeMilestones[i].isMilesStoneStart = false;
          break;
        }
      }
      return {
        ...state,
        checkTaskCompletedAgainstSprintLoading: false,
        checkTaskCompletedAgainstSprintSuccess: true,
        checkTaskCompletedAgainstSprintFailure: false,
        checkTaskCompletedAgainstSprintError: null,
        projectMilestones: completeMilestones,
      };
    case PROJECTMILESTONE.COMPLETE_SPRINT_IF_TASKS_COMPLETED_FAILURE:
      return {
        ...state,
        checkTaskCompletedAgainstSprintLoading: false,
        checkTaskCompletedAgainstSprintSuccess: false,
        checkTaskCompletedAgainstSprintFailure: true,
        checkTaskCompletedAgainstSprintError: null,
      };
    case PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_REQUEST:
      return {
        ...state,
        getAllSprintsWithoutStartedSprintLoading: true,
        getAllSprintsWithoutStartedSprintSuccess: false,
        getAllSprintsWithoutStartedSprintFailure: false,
        getAllSprintsWithoutStartedSprintError: null,
      };
    case PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_SUCCESS:
      return {
        ...state,
        getAllSprintsWithoutStartedSprintLoading: false,
        getAllSprintsWithoutStartedSprintSuccess: true,
        getAllSprintsWithoutStartedSprintFailure: false,
        getAllSprintsWithoutStartedSprintError: null,
        getAllSprintsWithoutStartedSprint: action.payload,
      };
    case PROJECTMILESTONE.GET_ALL_SPRINTS_WITHOUT_STARTED_SPRINT_FAILURE:
      return {
        ...state,
        getAllSprintsWithoutStartedSprintLoading: false,
        getAllSprintsWithoutStartedSprintSuccess: false,
        getAllSprintsWithoutStartedSprintFailure: true,
        getAllSprintsWithoutStartedSprintError: null,
      };
    case PROJECTMILESTONE.MOVE_SPRINT_TASKS_REQUEST:
      return {
        ...state,
        moveSprintTaskLoading: true,
        moveSprintTaskSuccess: false,
        moveSprintTaskFailure: false,
        moveSprintTaskError: null,
      };
    case PROJECTMILESTONE.MOVE_SPRINT_TASKS_SUCCESS:
      return {
        ...state,
        moveSprintTaskLoading: false,
        moveSprintTaskSuccess: true,
        moveSprintTaskFailure: false,
        moveSprintTaskError: null,
      };
    case PROJECTMILESTONE.MOVE_SPRINT_TASKS_FAILURE:
      return {
        ...state,
        moveSprintTaskLoading: false,
        moveSprintTaskSuccess: false,
        moveSprintTaskFailure: true,
        moveSprintTaskError: null,
      };
    default:
      return state;
  }
};
